export default {
  'attachment.search.name.placeholder': 'Please enter keywords, such as directory/name',
  'attachment.search.createby.placeholder': 'Please select the creator',
  'attachment.table.select': 'Select',
  'attachment.table.createby': 'Creator',
  'attachment.table.createTime': 'Creation Time',
  'attachment.table.dir': 'Directory',
};
